import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { __leadingZero } from "../../utils";
import { AiOutlineCalendar, AiOutlineClose } from "react-icons/ai";
interface IRange {
  start: string | null;
  end: string | null;
}

interface IDateRangePickerProps {
  startValue: string | null;
  endValue: string | null;
  onSelectRange?: (p: IRange) => void;
}

const DateRangePicker: React.FunctionComponent<IDateRangePickerProps> = ({
  startValue = null,
  endValue = null,
  onSelectRange = () => {},
}) => {
  const onChange = (dates: IRange) => {
    const { start, end } = dates;
    onSelectRange({ start, end });
  };

  return (
    <div className="flex items-center justify-center border border-[#ccc] rounded-md h-10 px-2">
      <DatePicker
        placeholderText="Date range..."
        selected={_parseDate(startValue)}
        onChange={(dates) => {
          onChange({
            start: _parseDateResultDB(dates[0]),
            end: _parseDateResultDB(dates[1]),
          });
        }}
        startDate={_parseDate(startValue)}
        endDate={_parseDate(endValue)}
        selectsRange
        dateFormat="MM-dd-yyyy"
        shouldCloseOnSelect
        closeOnScroll
        clearButtonTitle="Clear"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className="w-full"
        customInput={<input className=" w-[186px] outline-none" />}
      />
      {startValue && endValue ? (
        <button
          className="bg-red-100 w-6 h-6 flex justify-center items-center rounded-md text-red-400"
          onClick={() => {
            onChange({
              start: null,
              end: null,
            });
          }}
        >
          <AiOutlineClose />
        </button>
      ) : (
        <AiOutlineCalendar size={20} className="text-[#ccc]" />
      )}
    </div>
  );
};

export default DateRangePicker;
export const _parseDate = (date: string | null | undefined) => {
  if (date && date === "0000-00-00") return null;
  else if (date && date.split("-")[0].length === 4) {
    try {
      return new Date(parseInt(date.split("-")[0]), parseInt(date.split("-")[1]) - 1, parseInt(date.split("-")[2]));
    } catch (e) {
      return null;
    }
  }
  return null;
};
export const _parseDateResultDB = (date: Date | null) => {
  if (date) return `${date.getFullYear()}-${__leadingZero(date.getMonth() + 1)}-${__leadingZero(date.getDate())}`;
  return null;
};
